// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cqIF","title":"styles_title__2gM9l"};